import { Loader } from "components/common/Icons/Loader/Loader";
import { FontSources } from "store/features/memeGenerator/types/recentlyUsedFont";
import { Font } from "../Font/Font";
import type { useFontList } from "../useFontList";

type UseFontListReturn = ReturnType<typeof useFontList>;

interface GoogleFontsProps {
    googleFonts: UseFontListReturn["searchedGoogleFonts"];
    handleClick: UseFontListReturn["handleClick"];
    isLoadingMore: UseFontListReturn["isLoadingMore"];
}

export const GoogleFonts = ({ googleFonts, handleClick, isLoadingMore }: GoogleFontsProps) => {
    return (
        <>
            {googleFonts.length > 0 && (
                <div className="pl-4 text-sm text-irGray-500 border-t border-t-[#f3f3f3] dark:border-t-darkSurface-400 pt-1 mt-4 mb-2">
                    Google fonts
                </div>
            )}
            {googleFonts.map((font) => (
                <Font
                    key={font.family}
                    family={font.family}
                    source={FontSources.GOOGLE}
                    handleClick={handleClick}
                    close={close}
                />
            ))}
            {(isLoadingMore || googleFonts.length === 0) && (
                <div className="mt-2 flex items-center justify-center">
                    <Loader height={15} width={15} stroke={"var(--dark-gray)"} />
                </div>
            )}
        </>
    );
};
